export default {
      id: "withdrawal-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#withdrawal",
      toString: function () {
        return this.url;
      }
    }